import * as  React from 'react';

type PopupHeaderRightPartProps = {
    children: React.ReactChildren | React.ReactChild;
}

export default function PopupHeaderRightPart({ children }: PopupHeaderRightPartProps) {
    return <div className={`popup-form_header-right-part `}>
        {children}
    </div>;
}
